<template>
  <v-app-bar
    color="primary"
    dark
    fixed
    app
    dense>
    <v-toolbar-title v-text="title" />
    <v-spacer />
  </v-app-bar>
</template>

<script>
export default {
  data() {
    return {
      title: process.env.VUE_APP_HEADER_TITLE,
    };
  },
};
</script>
